import Header from './common/header.js';
import Common from './common/common.js';
import Form from './modules/form.js';

import Article from './pages/article.js';

function init() {
  Header.init();
  Common.init();
  Form.init();
  Article.init();
}

export default {
  init,
};
